import Axios from 'axios'

const state = {
  pengumuman: [],
  pengumuman_detail: {},
  loading: false,
  error: null,
  host: process.env.VUE_APP_API_HOST || 'http://localhost:8020',
  pagination: {
    currentPage: 0,
    totalPages: 0,
    totalElements: 0,
    pageSize: 10,
    hasNext: false,
    hasPrevious: false
  }
}

const getters = {
  getAllPengumuman: state => state.pengumuman,
  getPengumumanDetail: state => state.pengumuman_detail,
  isLoading: state => state.loading,
  getError: state => state.error,
  getPagination: state => state.pagination
}

const mutations = {
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_PENGUMUMAN(state, pengumuman) {
    state.pengumuman = pengumuman
  },
  SET_PENGUMUMAN_DETAIL(state, pengumuman) {
    state.pengumuman_detail = pengumuman
  },
  ADD_PENGUMUMAN(state, pengumuman) {
    state.pengumuman.unshift(pengumuman)
  },
  UPDATE_PENGUMUMAN(state, updatedPengumuman) {
    const index = state.pengumuman.findIndex(p => p.id === updatedPengumuman.id)
    if (index !== -1) {
      state.pengumuman.splice(index, 1, updatedPengumuman)
    }
  },
  DELETE_PENGUMUMAN(state, id) {
    state.pengumuman = state.pengumuman.filter(p => p.id !== id)
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_PAGINATION(state, paginationData) {
    state.pagination = {
      currentPage: paginationData.number,
      totalPages: paginationData.totalPages,
      totalElements: paginationData.totalElements,
      pageSize: paginationData.size,
      hasNext: !paginationData.last,
      hasPrevious: !paginationData.first
    }
  },
  CLEAR_ERROR(state) {
    state.error = null
  }
}

const actions = {
  async getPengumuman({ commit, rootState }, { page = 0, size = 10, search = '', kategori = '', aktif = '' } = {}) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      // Build query parameters
      const params = {
        page,
        size
      }
      
      // Add search parameter if provided
      if (search) {
        params.search = search
      }
      
      // Add kategori filter if provided
      if (kategori) {
        params.kategori = kategori
      }
      
      // Add aktif filter if provided
      if (aktif !== '') {
        params.aktif = aktif
      }
      
      // Get informasi data with pagination and filters
      const response = await Axios.get(`${state.host}/api/informasi`, {
        params,
        headers: {
          'Authorization': `Bearer ${rootState.token}`
        }
      })
      
      // Check if response has the new structure with status, message, data
      const responseData = response.data.data || response.data
      const content = responseData.content || responseData
      
      console.log('📡 API Response - First item sample:', content[0])
      
      // Transform the data to match the frontend expected format
      const transformedData = content.map(item => ({
        id: item.id,
        judul: item.judul,
        isi: item.isiInformasi,
        kategori: item.kategori, // Keep original API kategori 
        tanggal_terbit: formatDateString(item.tglAwalTayang),
        tanggal_selesai: formatDateString(item.tglAkhirTayang),
        is_popup: item.kategori === 'PAMFLET', // Set popup true untuk pamflet
        link: item.link, // Now available from API
        gambar: item.imageUrl, // Legacy field for backward compatibility
        imagePath: item.imagePath, // MinIO image path
        imageUrl: item.imageUrl, // External image URL
        filePath: item.filePath, // MinIO file attachment path (for PENGUMUMAN)
        fileName: item.fileName, // Original file name
        aktif: item.aktif,
        posisi: item.posisi || 'TENGAH',
        publishedDate: item.publishedDate,
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
        createdBy: item.createdBy,
        updatedBy: item.updatedBy,
        topicName: item.topicName || null
      }))
      
      console.log('🔄 Transformed data - First item sample:', transformedData[0])
      
      commit('SET_PENGUMUMAN', transformedData)
      commit('SET_PAGINATION', responseData)
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Gagal memuat pengumuman')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async getPengumumanById({ commit, rootState }, id) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      const response = await Axios.get(`${state.host}/api/informasi/${id}`, {
        headers: {
          'Authorization': `Bearer ${rootState.token}`
        }
      })
      
      const transformedData = {
        id: response.data.id,
        judul: response.data.judul,
        isi: response.data.isiInformasi,
        kategori: response.data.kategori,
        tanggal_terbit: formatDateString(response.data.tglAwalTayang),
        tanggal_selesai: formatDateString(response.data.tglAkhirTayang),
        is_popup: response.data.kategori === 'PAMFLET',
        link: response.data.link,
        gambar: response.data.imageUrl, // Legacy field for backward compatibility
        imagePath: response.data.imagePath, // MinIO image path
        imageUrl: response.data.imageUrl, // External image URL
        filePath: response.data.filePath, // MinIO file attachment path (for PENGUMUMAN)
        fileName: response.data.fileName, // Original file name
        aktif: response.data.aktif,
        posisi: response.data.posisi || 'TENGAH',
        publishedDate: response.data.publishedDate,
        createdAt: response.data.createdAt,
        updatedAt: response.data.updatedAt,
        createdBy: response.data.createdBy,
        updatedBy: response.data.updatedBy
      }
      
      commit('SET_PENGUMUMAN_DETAIL', transformedData)
      return transformedData
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Gagal memuat detail pengumuman')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createPengumuman({ commit, rootState }, pengumumanData) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      console.log('📤 CREATE - Input pengumumanData:', pengumumanData)
      
      // Create informasi object - prioritize imagePath for MinIO storage
      const informasiRequest = {
        judul: pengumumanData.judul,
        isiInformasi: pengumumanData.isi,
        kategori: pengumumanData.kategori, // Use API kategori directly
        tglAwalTayang: pengumumanData.tanggal_terbit,
        tglAkhirTayang: pengumumanData.tanggal_selesai,
        posisi: pengumumanData.posisi || 'TENGAH',
        aktif: pengumumanData.aktif !== false,
        imagePath: pengumumanData.imagePath || null, // MinIO image path (PRIORITY)
        imageUrl: pengumumanData.imageUrl || null, // External URL (FALLBACK)
        filePath: pengumumanData.filePath || null, // File attachment path (for PENGUMUMAN)
        fileName: pengumumanData.fileName || null, // File attachment name
        link: pengumumanData.link || null,
        topicName: pengumumanData.topicName || null
      }
      
      console.log('📤 CREATE - Request body:', informasiRequest)
      
      const response = await Axios.post(`${state.host}/api/informasi`, informasiRequest, {
        headers: {
          'Authorization': `Bearer ${rootState.token}`,
          'Content-Type': 'application/json'
        }
      })
      
      // Handle response structure (check if data is nested)
      const responseData = response.data.data || response.data
      
      // Transform response to match frontend format
      const transformedData = {
        id: responseData.id,
        judul: responseData.judul,
        isi: responseData.isiInformasi,
        kategori: responseData.kategori,
        tanggal_terbit: formatDateString(responseData.tglAwalTayang),
        tanggal_selesai: formatDateString(responseData.tglAkhirTayang),
        is_popup: responseData.kategori === 'PAMFLET',
        link: responseData.link,
        gambar: responseData.imageUrl,
        aktif: responseData.aktif,
        posisi: responseData.posisi || 'TENGAH',
        publishedDate: responseData.publishedDate,
        createdAt: responseData.createdAt,
        updatedAt: responseData.updatedAt,
        createdBy: responseData.createdBy,
        updatedBy: responseData.updatedBy,
        topicName: responseData.topicName || null
      }
      
      commit('ADD_PENGUMUMAN', transformedData)
      return { data: transformedData }
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Gagal membuat pengumuman')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updatePengumuman({ commit, rootState }, { id, pengumumanData }) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      console.log('=== STORE UPDATE DEBUG ===')
      console.log('1. Received pengumumanData:', pengumumanData)
      console.log('2. pengumumanData.imagePath:', pengumumanData.imagePath)
      console.log('3. pengumumanData.imageUrl:', pengumumanData.imageUrl)
      
      // Create informasi object - prioritize imagePath for MinIO storage
      const informasiRequest = {
        judul: pengumumanData.judul,
        isiInformasi: pengumumanData.isi,
        kategori: pengumumanData.kategori, // Use API kategori directly
        tglAwalTayang: pengumumanData.tanggal_terbit,
        tglAkhirTayang: pengumumanData.tanggal_selesai,
        posisi: pengumumanData.posisi || 'TENGAH',
        aktif: pengumumanData.aktif !== false,
        imagePath: pengumumanData.imagePath || null, // MinIO image path (PRIORITY)
        imageUrl: pengumumanData.imageUrl || null, // External URL (FALLBACK)
        filePath: pengumumanData.filePath || null, // File attachment path (for PENGUMUMAN)
        fileName: pengumumanData.fileName || null, // File attachment name
        link: pengumumanData.link || null,
        topicName: pengumumanData.topicName || null
      }
      
      console.log('4. Final informasiRequest:', informasiRequest)
      console.log('=== END STORE DEBUG ===')
      
      const response = await Axios.put(`${state.host}/api/informasi/${id}`, informasiRequest, {
        headers: {
          'Authorization': `Bearer ${rootState.token}`,
          'Content-Type': 'application/json'
        }
      })
      
      // Handle response structure (check if data is nested)
      const responseData = response.data.data || response.data
      
      // Transform response to match frontend format
      const transformedData = {
        id: responseData.id,
        judul: responseData.judul,
        isi: responseData.isiInformasi,
        kategori: responseData.kategori,
        tanggal_terbit: formatDateString(responseData.tglAwalTayang),
        tanggal_selesai: formatDateString(responseData.tglAkhirTayang),
        is_popup: responseData.kategori === 'PAMFLET',
        link: responseData.link,
        gambar: responseData.imageUrl,
        aktif: responseData.aktif,
        posisi: responseData.posisi || 'TENGAH',
        publishedDate: responseData.publishedDate,
        createdAt: responseData.createdAt,
        updatedAt: responseData.updatedAt,
        topicName: responseData.topicName || null
      }
      
      commit('UPDATE_PENGUMUMAN', transformedData)
      return { data: transformedData }
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Gagal mengupdate pengumuman')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deletePengumuman({ commit, rootState }, id) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      await Axios.delete(`${state.host}/api/informasi/${id}`, {
        headers: {
          'Authorization': `Bearer ${rootState.token}`
        }
      })
      
      commit('DELETE_PENGUMUMAN', id)
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Gagal menghapus pengumuman')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async toggleStatus({ commit, rootState }, id) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      const response = await Axios.put(`${state.host}/api/informasi/${id}/toggle-active`, {}, {
        headers: {
          'Authorization': `Bearer ${rootState.token}`
        }
      })
      
      // Transform response to match frontend format
      const transformedData = {
        id: response.data.id,
        judul: response.data.judul,
        isi: response.data.isiInformasi,
        kategori: response.data.kategori,
        tanggal_terbit: formatDateString(response.data.tglAwalTayang),
        tanggal_selesai: formatDateString(response.data.tglAkhirTayang),
        is_popup: response.data.kategori === 'PAMFLET',
        link: response.data.link,
        gambar: response.data.imageUrl,
        aktif: response.data.aktif,
        posisi: response.data.posisi || 'TENGAH',
        publishedDate: response.data.publishedDate,
        createdAt: response.data.createdAt,
        updatedAt: response.data.updatedAt,
        createdBy: response.data.createdBy,
        updatedBy: response.data.updatedBy
      }
      
      commit('UPDATE_PENGUMUMAN', transformedData)
      return { data: transformedData }
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Gagal mengubah status pengumuman')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async syncInformasi({ commit, rootState }, options = {}) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      const syncType = options.type || 'latest'
      let endpoint
      
      if (syncType === 'all') {
        // Admin full sync
        endpoint = `${state.host}/api/informasi/sync/lan-api`
      } else {
        // Default - latest news sync  
        endpoint = `${state.host}/api/informasi/sync/latest-news`
      }
      
      const response = await Axios.post(endpoint, {}, {
        headers: {
          'Authorization': `Bearer ${rootState.token}`,
          'Content-Type': 'application/json'
        }
      })
      
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Gagal melakukan sinkronisasi data'
      commit('SET_ERROR', errorMessage)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Upload image to MinIO
  async uploadImageToMinio({ rootState }, formData) {
    try {
      console.log('Uploading image to MinIO...')
      const response = await Axios.post(`${state.host}/api/informasi/upload`, formData, {
        headers: {
          'Authorization': `Bearer ${rootState.token}`,
          'Content-Type': 'multipart/form-data'
        }
      })
      console.log('MinIO image upload response:', response.data)
      return response.data
    } catch (error) {
      console.error('Error uploading image to MinIO:', error)
      throw error
    }
  },

  // Upload file attachment to MinIO (for PENGUMUMAN)
  async uploadFileToMinio({ rootState }, formData) {
    try {
      console.log('Uploading file to MinIO...')
      const response = await Axios.post(`${state.host}/api/informasi/upload-file`, formData, {
        headers: {
          'Authorization': `Bearer ${rootState.token}`,
          'Content-Type': 'multipart/form-data'
        }
      })
      console.log('MinIO file upload response:', response.data)
      return response.data
    } catch (error) {
      console.error('Error uploading file to MinIO:', error)
      throw error
    }
  }
}

// Helper functions
function formatDateString(dateString) {
  if (!dateString) return null
  // Handle both date formats: YYYY-MM-DD and ISO datetime
  if (dateString.includes('T')) {
    return dateString.split('T')[0] // Extract date part from ISO datetime
  }
  return dateString // Already in YYYY-MM-DD format
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
